import axios from 'axios';
// import authHeader from './_Helpers/auth-header.js';
import appconfig from './_Services/appconfig.js';
import https from 'https';

import { userService } from "./_Services/user-service";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
var config = appconfig;
var ApiURL = config.apiEndpoint;
console.log('ApiURL =' + ApiURL);
let sessionId = sessionStorage.getItem("sessionId");
if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("sessionId", sessionId);
    console.log("Generated new sessionId: " + sessionId);
}

function applyNoLogHeader(config) {
   if (new URLSearchParams(window.location.search).get('nolog') === '1') {
      config.headers['X-No-Log'] = '1';
   } else {
      delete config.headers['X-No-Log'];
   }
}

export const HttpClient = axios.create({
   baseURL: ApiURL,
   // withCredentials: true,
   headers: {
      'Content-Type': 'application/json',
      // Authorization: authHeader(),
      District: config.district || '',
      Secret: process.env.VUE_APP_SECRET || '',
      'X-Session-Id': sessionId,
   },
   httpsAgent: new https.Agent({
      rejectUnauthorized: false
   })
});

export const HttpFileClient = axios.create({
   baseURL: ApiURL,
   // withCredentials: true,
   headers: {
      'Content-Type': 'application/json',
      // Authorization: authHeader(),
      District: config.district || '',
      Secret: process.env.VUE_APP_SECRET || '',
      'X-Session-Id': sessionId,
   },
   responseType: 'arraybuffer',
});


HttpClient.interceptors.request.use(
  async config => {
     resetInactivityTimer();
     try {
        const token = await userService.getValidToken();
        config.headers.Authorization = token;
    } catch (err) {
      console.warn("No valid token");
    }
    applyNoLogHeader(config);
    return config;
  },
  error => Promise.reject(error)
);

HttpFileClient.interceptors.request.use(
  async config => {
    try {
      const token = await userService.getValidToken();
      config.headers.Authorization = token;
    } catch {
       console.warn("No valid token");
    }
    applyNoLogHeader(config);
    return config;
  },
  e => Promise.reject(e)
);

let inactivityTimer;
const INACTIVITY_LIMIT = (appconfig.inactivityLimitMinutes || 1) * 60 * 1000;

function resetInactivityTimer() {
   // console.log("resetInactivityTimer called");
   const tokenValid = userService.tokenValid();
   const now = Date.now();
   // const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);
   // const elapsed = now - (parseInt(lastActivity));
   // const remaining = INACTIVITY_LIMIT - elapsed;
   const remaining = userService.getInactivityRemainingTime();
   // console.log(`Inactivity remaining time: ${remaining}`);

   if (tokenValid) {
      // console.log(`resetInactivityTimer called with limit: ${INACTIVITY_LIMIT / 60000} minutes`);
      localStorage.setItem('rx_lastActivity', now.toString());
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
         doLogout();
         location.href = `${process.env.VUE_APP_BASE_URL}logininternaluser`
      }, INACTIVITY_LIMIT);
   }
   else if (remaining < 0) {
      doLogout();
   }

   // if (userService) {
   //    const tokenValid = userService.tokenValid();
   //    if (tokenValid) {
   //       console.log(`resetInactivityTimer called with limit: ${INACTIVITY_LIMIT / 60000} minutes`);
   //       clearTimeout(inactivityTimer);
   //       inactivityTimer = setTimeout(() => {
   //          userService.logout();
   //          location.href = `${process.env.VUE_APP_BASE_URL}logininternaluser`
   //       }, INACTIVITY_LIMIT);
   //    }
   //    // else{
   //    //    localStorage.removeItem('token');
   //    //    localStorage.removeItem('tokenExpires');
   //    // }
   // } else {
   //    console.warn('user service not valid, skipping inactivity timer reset.');
   // }
}
// resetInactivityTimer();

function doLogout() {
   console.log("Inactivity limit reached, logging out...");
   localStorage.removeItem('token');
   localStorage.removeItem('tokenExpires');
   localStorage.removeItem('rx_lastActivity');
}